<template>
  <Drawer
    :width="drawerWidth"
    title="付款记录"
    :mask-closable='false'
    v-model="drawerOpened"
  >
    <div class="drawer-content">
    <PaymentApplicationPanel ref="PaymentApplicationPanel" />

    </div>
  </Drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { arrayIntersection } from "@/utils";
import dayjs from "dayjs";
import lodash from "lodash";
import PaymentApplicationPanel from "./PaymentApplicationPanel.vue";

export default {
  name: "PaymentDrawer",
  components: { PaymentApplicationPanel },
  data() {
    return {
      drawerWidth: 800,
      drawerOpened: false,
      openedPayment: null,
    }
  },
  computed: {
    ...mapState({
      companyList: (state) => state.company.companyList,
      user: (state) => state.auth.currentUser,
    }),
  },
  methods: {
    ...mapActions({
      createPayment: "payment/createPaymentAction",
      updatePayment: "payment/updatePaymentAction",
      getCustomerSimpleList: "customer/getCustomerSimpleListAction",
      getSimpleUserList: "user/getSimpleUserListAction",
      getSupplier: "supplier/getSupplierAction",
      getEntity: "entity/getEntityAction",
      getCompanyList: "company/getCompanyListAction",
      getBill: "bill/getBillAction",
    }),
    async openDrawer(payment, type) {
      this.drawerOpened = true;
    },
  },
  created() {

  },
  mounted() {

  },
  destroyed() {

  },
};
</script>

<style scoped lang="stylus">

</style>
